// extracted by mini-css-extract-plugin
export var addButton = "_ft-0";
export var border = "_ft-8";
export var check = "_ft-h";
export var danger = "_ft-6";
export var dropdownContainer = "_ft-1";
export var editModalBody = "_ft-j";
export var footerContainer = "_ft-i";
export var fullWidth = "_ft-a";
export var hide = "_ft-9";
export var icon = "_ft-3";
export var input = "_ft-7";
export var inputFlex = "_ft-b";
export var inputWrapper = "_ft-c";
export var manualFocus = "_ft-5";
export var optionButton = "_ft-4";
export var pillWrapper = "_ft-e";
export var pointer = "_ft-2";
export var showOverflow = "_ft-f";
export var tagsFlex = "_ft-d";
export var xButton = "_ft-g";